/* eslint-disable complexity */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip, faIdBadge } from '@fortawesome/pro-light-svg-icons';

import { getFormattedDate } from 'Src/common/utilities/moment_util';
import './style.scss';

const CHECKBOX_VALUE = 5;
const MULTI_SELECT_VALUE = 7;
const RICH_TEXT_VALUE = 21;
const FIELD_TYPES_HAVE_MULTI_VALUES = [CHECKBOX_VALUE, MULTI_SELECT_VALUE];

function DisplayFormFields({ submissionData, fieldsXHash, itemClassName }) {
  function getValueFormatted(fieldDetail, field) {
    if (
      fieldDetail
      && FIELD_TYPES_HAVE_MULTI_VALUES.findIndex((field_type) => field_type === fieldDetail.field_type) > -1
    ) {
      return (
        <Choose>
          <When condition={field.value}>
            <ul className="submission-item-value arc-p arc-color-B45">
              {field.value && field.value.split(',').map((value, index) => <li key={index}>{value}</li>)}
            </ul>
          </When>
          <Otherwise>
            <p className="submission-item-value arc-p arc-color-B45">-</p>
          </Otherwise>
        </Choose>
      );
    }
    if (fieldDetail && fieldDetail.field_type === RICH_TEXT_VALUE && field.value) {
      return (
        <div
          className="submission-item-value submission-item-value-rich-field  arc-p"
          dangerouslySetInnerHTML={{ __html: field.value }} />
      );
    }
    if (fieldDetail && fieldDetail.field_type === 10 && field.value) {
      field.value = getFormattedDate(field.value, 'DD MMM YYYY');
    }

    if (fieldDetail && fieldDetail.field_type === 9 && field.value) {
      return (
        <p className="submission-item-value arc-p arc-color-B45">
          <a href={field.value} download={field.value}>
            {' '}
            <FontAwesomeIcon icon={faPaperclip} />
            {' '}
            {field.display_value}
          </a>
        </p>
      );
    }

    if (fieldDetail && fieldDetail.field_type === 17 && field.value) {
      const urls = field.value.split(',');
      const names = field.display_value.split(',');
      return urls.map((url, index) => (
        <p key={index} className="submission-item-value arc-p arc-color-B45">
          <a href={url} download={url}>
            <FontAwesomeIcon icon={faPaperclip} />
            {' '}
            {names[index]}
          </a>
        </p>
      ));
    }

    return <p className="submission-item-value arc-p arc-color-B45">{field.display_value || '-'}</p>;
  }

  function isFieldForInternalPurpose(id) {
    const fieldProperty = fieldsXHash[id];
    return fieldProperty && fieldProperty.visible === false;
  }

  function renderItem(field) {
    const fieldDetail = fieldsXHash[field.field_id] || {};
    return (
      <div className="submission-item">
        <p className="submission-item-key arc-label arc-font-weight-medium arc-color-black">
          {fieldDetail.title || field.label || 'untitled'}
        </p>
        {getValueFormatted(fieldDetail, field)}
      </div>
    );
  }

  return (
    <div className="custom-form-fields-wrapper">
      <If condition={submissionData.field_entries}>
        {submissionData?.field_entries?.map((entry) => (
          <div className={`submission-edit-detail-item ${itemClassName}`} key={entry.field_id}>
            <If condition={isFieldForInternalPurpose(entry.field_id)}>
              <div className="pre-icon-form-internal-field">
                <FontAwesomeIcon icon={faIdBadge} className="internal-field-icon" />
              </div>
            </If>
            {renderItem(entry)}
          </div>
        ))}
      </If>
    </div>
  );
}

export default DisplayFormFields;
